import type { Route } from 'nextjs-routes';

const TEMPLATE_MAP: Record<Route['pathname'], string> = {
  '/': 'کاوشگر رسمی %network_name%',
  '/txs': 'تراکنش‌های %network_name%',
  '/internal-txs': 'تراکنش‌های داخلی %network_name%',
  '/txs/kettle/[hash]': 'تراکنش‌های Kettle با هش %hash% در %network_name%',
  '/tx/[hash]': 'تراکنش %hash% در %network_name%',
  '/blocks': 'بلاک‌های %network_name%',
  '/block/[height_or_hash]': 'بلاک %height_or_hash% در %network_name%',
  '/block/countdown': 'شمارش معکوس بلاک در %network_name%',
  '/block/countdown/[height]': 'شمارش معکوس بلاک %height% در %network_name%',
  '/accounts': 'حساب‌های برتر %network_name%',
  '/accounts/label/[slug]': 'آدرس‌های دارای برچسب %slug% در %network_name%',
  '/address/[hash]': 'جزئیات آدرس %hash% در %network_name%',
  '/projects': 'پروژه‌های ثبت‌شده در %network_name%',
  '/verified-contracts': 'همه قراردادهای %network_name%',
  '/tokens': 'فهرست توکن‌های %network_name%',
  '/token/[hash]': 'جزئیات توکن در %network_name%',
  '/token/[hash]/instance/[id]': 'نمونه NFT در %network_name%',
  '/apps': 'برنامه‌های غیرمتمرکز %network_name%',
  '/apps/[id]': 'برنامه غیرمتمرکز در %network_name%',
  '/stats': 'نمودارها و آمار %network_name%',
  '/stats/[id]': 'نمودار %id% در %network_name%',
  '/api-docs': 'مستندات API شبکه %network_name%',
  '/graphiql': 'جست‌وجوی داده با GraphQL در %network_name%',
  '/search-results': 'نتیجه جست‌وجوی %q% در %network_name%',
  '/auth/profile': 'پروفایل من در %network_name%',
  '/account/merits': 'امتیازهای من در %network_name%',
  '/account/watchlist': 'فهرست پیگیری در %network_name%',
  '/account/api-key': 'کلیدهای API در %network_name%',
  '/account/custom-abi': 'ABI سفارشی در %network_name%',
  '/account/tag-address': 'برچسب‌های خصوصی در %network_name%',
  '/account/verified-addresses': 'آدرس‌های تأییدشده من در %network_name%',
  '/public-tags/submit': 'درخواست برچسب عمومی در %network_name%',
  '/withdrawals': 'برداشت‌های %network_name%',
  '/txn-withdrawals': 'انتقال پیام از L2 به L1 در %network_name%',
  '/visualize/sol2uml': 'نمودار Solidity UML در %network_name%',
  '/csv-export': 'خروجی CSV از %network_name%',
  '/deposits': 'واریزهای L1 به L2 در %network_name%',
  '/output-roots': 'ریشه‌های خروجی %network_name%',
  '/dispute-games': 'فرایندهای اختلاف %network_name%',
  '/batches': 'دسته‌های تراکنش %network_name%',
  '/batches/[number]': 'دسته تراکنش L2 شماره %number% در %network_name%',
  '/batches/celestia/[height]/[commitment]': 'دسته تراکنش L2 در ارتفاع %height% شبکه %network_name%',
  '/blobs/[hash]': 'جزئیات Blob با هش %hash% در %network_name%',
  '/ops': 'عملیات کاربران در %network_name%',
  '/op/[hash]': 'عملیات کاربر با هش %hash% در %network_name%',
  '/404': 'صفحه در %network_name% پیدا نشد',
  '/name-domains': 'دامنه‌های نام در %network_name%',
  '/name-domains/[name]': 'جزئیات دامنه %name% در %network_name%',
  '/validators': 'فهرست اعتبارسنج‌های %network_name%',
  '/validators/[id]': 'جزئیات اعتبارسنج %id% در %network_name%',
  '/epochs': 'دوره‌های %network_name%',
  '/epochs/[number]': 'جزئیات دوره %number% در %network_name%',
  '/gas-tracker': 'رهگیری کارمزد گس در %network_name%',
  '/mud-worlds': 'فهرست جهان‌های MUD در %network_name%',
  '/token-transfers': 'انتقال‌های توکن در %network_name%',
  '/advanced-filter': 'فیلتر پیشرفته %network_name%',
  '/pools': 'استخرهای DEX در %network_name%',
  '/pools/[hash]': 'جزئیات استخر در %network_name%',
  '/interop-messages': 'پیام‌های میان‌زنجیره‌ای %network_name%',
  '/chain/[chain-slug]/accounts/label/[slug]': 'آدرس‌های دارای برچسب %slug% در %network_name%',
  '/chain/[chain-slug]/address/[hash]': 'جزئیات آدرس %hash% در %network_name%',
  '/chain/[chain-slug]/block/[height_or_hash]': 'جزئیات بلاک %height_or_hash% در %network_name%',
  '/chain/[chain-slug]/tx/[hash]': 'جزئیات تراکنش %hash% در %network_name%',
  '/operations': 'عملیات %network_name%',
  '/operation/[id]': 'عملیات %id% در %network_name%',

  // service routes, added only to make typescript happy
  '/login': 'ورود به %network_name%',
  '/sprite': 'مجموعه آیکون SVG شبکه %network_name%',
  '/chakra': 'نمایش رابط Chakra UI در %network_name%',
  '/api/metrics': 'معیارهای Prometheus در %network_name%',
  '/api/monitoring/invalid-api-schema': 'خطای ساختار API در %network_name%',
  '/api/log': 'گزارش درخواست‌های API در %network_name%',
  '/api/media-type': 'نوع رسانه API در %network_name%',
  '/api/proxy': 'پراکسی API در %network_name%',
  '/api/csrf': 'توکن CSRF در %network_name%',
  '/api/healthz': 'سلامت API در %network_name%',
  '/api/config': 'تنظیمات API در %network_name%',
  '/api/saba-dashboard': 'آمار شبکه در %network_name%',
  '/api/saba-projects': 'پروژه‌های ثبت‌شده در %network_name%',
  '/api/saba-token-leaderboard': 'دارندگان برتر توکن‌های پروژه در %network_name%',
  '/api/saba-validators': 'آمار شبکه در %network_name%',
};

const TEMPLATE_MAP_ENHANCED: Partial<Record<Route['pathname'], string>> = {
  '/token/[hash]': 'جزئیات توکن %symbol_or_name% در %network_name%',
  '/token/[hash]/instance/[id]': 'نمونه توکن %symbol_or_name% در %network_name%',
  '/apps/[id]': '%network_name% - %app_name%',
  '/address/[hash]': 'جزئیات آدرس %domain_name% در %network_name%',
  '/stats/[id]': 'نمودار %title% در %network_name%',
};

export function make(pathname: Route['pathname'], isEnriched = false) {
  const template = (isEnriched ? TEMPLATE_MAP_ENHANCED[pathname] : undefined) ?? TEMPLATE_MAP[pathname];
  const postfix = ' | صبانفت';

  return (template + postfix).trim();
}
